import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Toast } from "react-bootstrap";
import localization from "assets/localization/localization";
import "./style.css";

const AppNotifications = ({
  closeToast,
  isSuccess = false,
  visible,
  message,
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(visible);
  }, [visible]);

  const showHideFunc = () => {
    setShow(false);
    closeToast(false, "");
  };

  return (
    <>
    {(message) ?
        <Toast
        className={`toastMessage ${isSuccess ? "success" : "failed"}`}
        show={show}
        delay={4000}
        onClose={showHideFunc}
        autohide
      >
        <Toast.Body>
          <button onClick={showHideFunc}>
            {" "}
            <span role="img" aria-label="close">
              &#10060;
            </span>{" "}
          </button>
          <p className="title">
            {isSuccess ? localization.success : localization.failed}
          </p>
          <p className="description">{message !== 'Success' ? message : localization.failed || localization.oppsWrong}</p>
        </Toast.Body>
      </Toast>
      : null}
    </>
  );
};

AppNotifications.propTypes = {
  closeToast: PropTypes.func,
  visible: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default AppNotifications;
